import * as PIXI from 'pixi.js';
const deviceRatio = window.devicePixelRatio || 1; //For Retina Display

export default function DrawText(
  text,
  pixiView,
  tailPosition = 'bottom',
  fontState = 'gothic',
  fontColorState = '#000',
  fontStyleState = 'f1',
  aspectState = 'portrait',
  scaleState,
) {
  //Stule Settings
  var padding = 10;
  var maxWidth = 550;
  var maxFontWidth = 500;
  var cornerRadius = 15;
  var fontFamily = 'Hiragino Kaku Gothic Std';
  var fontSize = 36;
  //var fontStyle = fontStyleState;
  var tailWidth = 30;
  var tailHeight = 20;
  var fillColor = '#000000';
  var bubbleColor = '#FFFFFF';
  var strokeColor = '#FFFFFF';
  var fontWeight = 'bold';
  var strokeThickness = 13;
  var dropShadow = false;
  var dropShadowColor = '#000000';
  var dropShadowBlur = 0;
  var dropShadowAngle = 45 * (Math.PI / 180);
  var dropShadowDistance = 6;
  var showBubble = false;
  var textAlign = 'center';

  if (fontStyleState == 'f0') {
    const container = new PIXI.Container();
    return container;
  }

  if (fontStyleState == 'f1') {
    fillColor = fontColorState;
    bubbleColor = '#FFFFFF';
    strokeThickness = 0;
    dropShadow = false;
    showBubble = true;
  }

  if (fontStyleState == 'f2') {
    fillColor = '#FFFFFF';
    bubbleColor = fontColorState;
    strokeThickness = 0;
    dropShadow = false;
    showBubble = true;
  }

  if (fontStyleState == 'f3') {
    fillColor = fontColorState;
    strokeColor = '#FFFFFF';
    strokeThickness = 8;
    dropShadow = false;
  }

  if (fontStyleState == 'f4') {
    fillColor = '#FFFFFF';
    strokeColor = fontColorState;
    strokeThickness = 8;
    dropShadow = false;
  }

  if (fontStyleState == 'f5') {
    fillColor = '#FFFFFF';
    strokeColor = fontColorState;
    strokeThickness = 0;
    dropShadow = true;
    dropShadowBlur = 5;
    dropShadowAngle = 0;
    dropShadowDistance = 0;
  }

  if (fontStyleState == 'f6') {
    fillColor = fontColorState;
    strokeColor = '#FFFFFF';
    strokeThickness = 8;
    dropShadow = true;
    dropShadowColor = '#575757';
    dropShadowBlur = 0;
    dropShadowAngle = 45 * (Math.PI / 180);
    dropShadowDistance = 6;
  }

  //Square
  if (showBubble && aspectState == 'square') {
    maxWidth = maxWidth - padding * 2;
    maxFontWidth = maxFontWidth * 0.6 - padding * 2;
    fontSize = fontSize * 0.6;
    if (tailPosition == 'left') {
      textAlign = 'left';
      maxWidth = maxWidth * 0.7;
      maxFontWidth = maxFontWidth * 0.7;
      fontSize = fontSize * 0.7;
      padding = padding * 0.5;
      cornerRadius = cornerRadius * 0.5;
      tailWidth = tailWidth * 0.5;
      tailHeight = tailHeight * 0.5;
    }
  }

  //Portrait
  if (showBubble && aspectState == 'portrait') {
    maxWidth = 400;
    maxFontWidth = 350;
    fontSize = 24;
    if (tailPosition == 'left') {
      maxWidth = maxWidth * 0.8;
      maxFontWidth = maxFontWidth * 0.8;
      fontSize = fontSize * 0.8;
      padding = padding * 0.6;
      cornerRadius = cornerRadius * 0.6;
      tailWidth = tailWidth * 0.6;
      tailHeight = tailHeight * 0.6;
    }
  } else if (aspectState == 'portrait') {
    maxWidth = 400;
    maxFontWidth = 350;
    fontSize = 24;
  }

  //Landscape
  if (showBubble && aspectState == 'landscape') {
    if (tailPosition == 'left') {
      textAlign = 'left';
      maxWidth = 400;
      maxFontWidth = 250;
      fontSize = 20;
      padding = padding * 0.6;
      cornerRadius = cornerRadius * 0.6;
      tailWidth = tailWidth * 0.6;
      tailHeight = tailHeight * 0.6;
    } else {
      maxWidth = 700;
      maxFontWidth = 600;
      fontSize = 24;
    }
  } else if (aspectState == 'landscape') {
    maxWidth = 700;
    maxFontWidth = 450;
    fontSize = 24;
  }

  //Detect Roman letters or Japanese/Chinese letters
  if (predominantCharacterWidth(text) == 'Full-width') {
    text = wrapJapaneseText(text, Math.floor((maxWidth - 2 * padding) / fontSize));
  }

  //Set fontFamily
  if (fontState == 'gothic') {
    fontFamily = 'Hiragino Kaku Gothic Pro W6';
    //fontWeight = 'normal';
  } else if (fontState == 'mincho') {
    fontFamily = 'Hiragino Mincho Pro';
  } else if (fontState == 'round') {
    fontFamily = 'Hiragino Maru Gothic Pro';
  }

  let textStyle;
  textStyle = new PIXI.TextStyle({
    fontFamily: fontFamily,
    fontSize: fontSize,
    wordWrap: true,
    fontWeight: fontWeight,
    lineHeight: fontSize * 1.4,
    wordWrapWidth: maxWidth - 2 * padding,
    align: textAlign,
    breakWords: false,
    miterLimit: 3,
    fill: fillColor,
    stroke: strokeColor,
    strokeThickness: strokeThickness,
    dropShadow: dropShadow,
    dropShadowColor: dropShadowColor,
    dropShadowBlur: dropShadowBlur,
    dropShadowAngle: dropShadowAngle,
    dropShadowDistance: dropShadowDistance,
  });

  const pixiText = new PIXI.Text(text, textStyle);

  //Change font size according to length of texts (Landscape's font size is always the same)
  if (aspectState != 'landscape') {
    while (pixiText.width < maxFontWidth && textStyle.fontSize < 200 && textStyle.fontSize < 80) {
      textStyle.fontSize += 0.2;
      textStyle.strokeThickness += 0.02;
      pixiText.style = textStyle;
    }
  }

  const textWidth = Math.min(pixiText.width, maxWidth);
  const textHeight = pixiText.height;

  //Set position
  let x;
  let y;

  x = (pixiView.view.width / deviceRatio / scaleState - textWidth) / 2;
  y = (pixiView.view.height * 0.05) / deviceRatio / scaleState; //

  //Square
  if (showBubble && aspectState == 'square') {
    if (tailPosition == 'left') {
      x = 40;
      y = pixiView.view.height / deviceRatio / scaleState;
      y = y - textHeight - 330;
    } else {
      y = y + 10;
    }
  }

  //Portrait
  if (aspectState == 'portrait') {
    if (tailPosition == 'left' && showBubble) {
      y = pixiView.view.height / deviceRatio / scaleState - textHeight - 320; //
    } else if (showBubble) {
      y = (pixiView.view.height * 0.1) / deviceRatio / scaleState; //
    } else {
      if (tailPosition == 'left') {
        y = (pixiView.view.height * 0.4) / deviceRatio / scaleState; //
      } else {
        y = (pixiView.view.height * 0.1) / deviceRatio / scaleState; //
      }
    }

    //Edit Text Mode
    if (tailPosition == 'center') {
      y = y + 200;
    }
  }

  //Landscape
  if (aspectState == 'landscape') {
    if (showBubble) {
      if (tailPosition == 'left') {
        x = 30;
        y = pixiView.view.height / deviceRatio / scaleState;
        y = y - textHeight - 280;
      } else {
        x = (pixiView.view.width / deviceRatio / scaleState - textWidth) / 2;
        //y = pixiView.view.height / deviceRatio / scaleState / 2; //
        y = (pixiView.view.height * 0.1) / deviceRatio / scaleState; //
      }
    } else {
      y = pixiView.view.height / deviceRatio / scaleState;
      y = y - textHeight - 30;
    }
  }

  pixiText.position.set(x, y);

  //Add container
  const container = new PIXI.Container();
  container.sortableChildren = true;
  container.zIndex = 5;

  /*-------------------  Add bubble Start ------------------ */

  if (showBubble) {
    x = x - padding * 2;
    y = y - padding;
    const bubbleWidth = textWidth + 2 * padding * 2;
    const bubbleHeight = textHeight + 2 * padding;
    const shadowOffset = 5;
    const graphicsShadow = new PIXI.Graphics();
    graphicsShadow.beginFill(0x000000, 0.2);
    graphicsShadow.drawRoundedRect(x, y + shadowOffset, bubbleWidth, bubbleHeight, cornerRadius);

    // Tail shadow
    if (tailPosition == 'left') {
      // graphicsShadow.moveTo(x, y + bubbleHeight / 2 - tailWidth / 2);
      // graphicsShadow.lineTo(x - tailHeight, y + bubbleHeight / 2);
      // graphicsShadow.lineTo(x, y + bubbleHeight / 2 + tailWidth / 2);
      graphicsShadow.moveTo(x + padding + 90, y + bubbleHeight);
      graphicsShadow.lineTo(x + padding + 90 + 10, y + bubbleHeight + 20);
      graphicsShadow.lineTo(x + padding + 90 + 20, y + bubbleHeight);
    } else {
      graphicsShadow.moveTo(x + bubbleWidth / 2 - tailWidth / 2, y + bubbleHeight + shadowOffset);
      graphicsShadow.lineTo(x + bubbleWidth / 2, y + bubbleHeight + tailHeight + shadowOffset);
      graphicsShadow.lineTo(x + bubbleWidth / 2 + tailWidth / 2, y + bubbleHeight + shadowOffset);
    }

    graphicsShadow.endFill();

    // Blur shadow
    const blurFilter = new PIXI.filters.BlurFilter();
    blurFilter.blur = 4;
    graphicsShadow.filters = [blurFilter];

    // speech bubble
    const graphics = new PIXI.Graphics();
    graphics.beginFill(convertColorCode(bubbleColor));
    graphics.drawRoundedRect(x, y, bubbleWidth, bubbleHeight, cornerRadius);

    // tail position
    if (tailPosition == 'left') {
      // graphics.moveTo(x, y + bubbleHeight / 2 - tailWidth / 2);
      // graphics.lineTo(x - tailHeight, y + bubbleHeight / 2);
      // graphics.lineTo(x, y + bubbleHeight / 2 + tailWidth / 2);

      if (aspectState == 'portrait' && tailPosition == 'left') {
        graphics.moveTo(x + bubbleWidth / 2 - tailWidth / 2, y + bubbleHeight);
        graphics.lineTo(x + bubbleWidth / 2, y + bubbleHeight + tailHeight);
        graphics.lineTo(x + bubbleWidth / 2 + tailWidth / 2, y + bubbleHeight);
      } else {
        graphics.moveTo(x + padding + 90, y + bubbleHeight);
        graphics.lineTo(x + padding + 90 + 10, y + bubbleHeight + 15);
        graphics.lineTo(x + padding + 90 + 20, y + bubbleHeight);
      }
    } else {
      graphics.moveTo(x + bubbleWidth / 2 - tailWidth / 2, y + bubbleHeight);
      graphics.lineTo(x + bubbleWidth / 2, y + bubbleHeight + tailHeight);
      graphics.lineTo(x + bubbleWidth / 2 + tailWidth / 2, y + bubbleHeight);
    }

    graphics.endFill();
    container.addChild(graphicsShadow);
    container.addChild(graphics);
  }

  /*-------------------  Add bubble End ------------------ */

  container.addChild(pixiText);
  pixiView.stage.addChild(container);
  return container;
}

//For Japanese and Chinese letters
function wrapJapaneseText(text, maxCharsPerLine) {
  let wrappedText = '';
  let charsCount = 0;

  for (let char of text) {
    wrappedText += char;
    charsCount++;

    if (charsCount >= maxCharsPerLine) {
      wrappedText += '\n';
      charsCount = 0;
    }
  }

  return wrappedText;
}

//detect text will be Japanese/Chinese or Roman
function predominantCharacterWidth(text) {
  const fullWidthMatches =
    text.match(
      /[\uFF01-\uFF60\uFFE0-\uFFE6\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/g,
    ) || [];
  const halfWidthMatches = text.match(/[\u0020-\u007E]/g) || [];

  if (fullWidthMatches.length > halfWidthMatches.length) {
    return 'Full-width';
  } else {
    return 'Half-width';
  }
}

function convertColorCode(color) {
  if (color.startsWith('#')) {
    return '0x' + color.slice(1);
  }
  return color;
}
